import React, { useEffect } from "react";
import { Sparkles } from "lucide-react";
import { AiConnections } from "@/components/ai/AiConnections";

export default function AiKeys() {
  useEffect(() => { document.title = "AI Keys — Living Wisdom Explorer"; }, []);
  return (
    <div className="max-w-3xl mx-auto px-6 py-10 relative z-10" data-testid="ai-keys-page">
      <div className="flex items-center gap-2 text-primary mb-1">
        <Sparkles className="w-4 h-4" />
        <span className="text-xs font-semibold uppercase tracking-wide">Bring your own AI</span>
      </div>
      <h1 className="font-serif text-4xl tracking-tight-serif text-foreground">AI Keys</h1>
      <p className="text-muted-foreground mt-2 max-w-xl">
        Connect your own AI keys to research topics inside the app. Perplexity finds cited sources; Claude and ChatGPT help you draft.
        Nothing you research enters the knowledge graph until a human approves it.
      </p>
      <div className="mt-8">
        <AiConnections />
      </div>
    </div>
  );
}
